import { render, staticRenderFns } from "./forcedReturn.vue?vue&type=template&id=355367e0&"
import script from "./forcedReturn.vue?vue&type=script&lang=js&"
export * from "./forcedReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports